import { PostTypes } from 'constants/postTypes'

import { InProgressPost } from 'types/post'

export const createEmptyStep = () => ({})

export const createEmptyPost = (postType: PostTypes): InProgressPost => ({
  isDraft: false,
  visibility: 'premium',
  type: postType,
  title: '',
  steps: postType === PostTypes.WORKOUT ? [] : [createEmptyStep()],
  hasSteps: true,
  viewerCategories: [],
  programIds: [],
  publishedToProgramIds: [],
  combinedCategoriesAndProgramIds: [],
})
